export default __webpack_public_path__ + "static/media/ISMO CLASS-9_SYLLABUS_2025-26.ab003f56.pdf";